import React from 'react'

export const Italic = ({ children }) => {
  return <em className='italic'>{children}</em>
}
